<template>
	<api-error v-for="err in errors" :level="err.level" :message="err.message" style="margin-bottom:4px"></api-error>
	<array-part :part="part" :data="data" :readonly="readonly" :viewmode="viewmode"></array-part>
</template>

<script setup lang="ts">
import ArrayPart from "../../containers/ArrayPart.vue";
import {type PartProps, partProps} from "../../Part";
import {provide, computed} from "vue";
import type {MemberParties} from "@t/fd/layout/MemberParties";
import {parentOrgKey} from "@fd/PartInjectKeys.ts";
import useContainer from "@fd/containers/Container.ts";
import ApiError from "@fd/helpers/ApiError.vue";

const uprops = defineProps({...partProps});
const props = uprops as PartProps;
const mp = computed<MemberParties>(() => props.part as MemberParties);

provide(parentOrgKey, computed<boolean>(() => mp.value.direction === "parents"));  // signal direction to member-party

const {errors} = useContainer(props);

</script>

<style>
</style>
